import {
  PageItem_CtaButtonContentBlock,
  PageItem_CtaButtonContentBlock_Style,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_page/v1/service.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions} from '@aboutyou/tracking';
import {
  CTAStyle,
  ContentBlockCTA,
  gridContainer,
  mediaTabletAndUp,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

const styleMap: Record<PageItem_CtaButtonContentBlock_Style, CTAStyle> = {
  [PageItem_CtaButtonContentBlock_Style.UNSPECIFIED]: 'primary',
  [PageItem_CtaButtonContentBlock_Style.PRIMARY]: 'primary',
  [PageItem_CtaButtonContentBlock_Style.TEXT_LINK]: 'text-link',
};

export const StoryCtaButton: React.FC<{
  content: PageItem_CtaButtonContentBlock;
  streamPosition: number;
  testId?: string;
}> = ({content, streamPosition, testId = 'storyCtaButton'}) => {
  if (content.text === '' || content.linkTarget === undefined) return null;

  return (
    <Wrapper
      data-testid={`${testId}Tracker`}
      promotion={{
        source: TrackingPromotionCreative.GenericPromotion,
        promotionTracker: content.promotionTracker,
      }}
      streamPosition={streamPosition}
    >
      <ContentBlockCTA
        testId={testId}
        text={{text: content.text, style: styleMap[content.style]}}
        link={{url: content.linkTarget.url}}
        size="lg"
      />
    </Wrapper>
  );
};

const Wrapper = styled(TrackPromotions)`
  text-align: center;

  @media ${mediaTabletAndUp} {
    ${gridContainer}

    & > * {
      width: 100%;
    }
  }

  & > a[data-size='lg'][data-variant='primary'] {
    margin-inline: auto;
  }
`;
